import { default as styled } from '@emotion/styled'
import { TabPanel } from '@sitecore-ui/design-system'

export const StyledTabPanel = styled(TabPanel)`
  padding: 0;
`
